import { Component, type ReactNode } from "react";
import * as Sentry from "@sentry/react";
import { Button } from "@/ui/button";

type State = { error: Error | null };

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
          <h1 className="text-2xl font-semibold">Đã có lỗi</h1>
          <p className="text-sm text-muted">{this.state.error.message}</p>
          <Button onClick={() => location.reload()}>Tải lại</Button>
        </div>
      );
    }
    return this.props.children;
  }
}
